import { FormattedMessage as FM } from "react-intl";
import { PresentIcon, EditIcon } from "components/Icons";

export function DeliveryHeader({ delivery, onResetDelivery }) {
  return (
    <div className="gird grid-cols-1 tablet:grid tablet:grid-cols-3 lg:grid lg:grid-cols justify-between items-start lg:items-center gap-6">
      <div className="grow grid col-span-2">
        <h1 className="text-2xl font-bold text-zinc-800 flex items-center gap-2 mb-1.5">
          <span className="p-2 bg-zinc-900 rounded-lg shadow-sm justify-center  items-center">
            <PresentIcon />
          </span>
          <FM id={"delivery.panel"} defaultMessage="Panel de Domicilios" />
        </h1>
        <p
          className="text-zinc-500 mt-1 flex items-center gap-2 pl-1 "
        >
          <FM id="sale.sale.delivery.panel_text" />
        </p>
      </div>

      <div className="items-center gap-4 w-full">
        {delivery && (
          <div className=" items-center gap-3 pt-5">
            <div className="flex flex-col items-end">
              <span className="text-base font-bold text-zinc-500 uppercase tracking-widest mr-1">
                <FM id="sale.sale.delivery" />
              </span>
              <div className="flex items-center gap-2 bg-white border border-zinc-200 rounded-lg pl-3 pr-1 py-2 shadow-sm">
                <span className="text-xs  font-bold text-zinc-700 text-center">
                  {delivery.rec_name}
                </span>
                <button
                  type="button"
                  onClick={onResetDelivery}
                  className="p-1 hover:bg-zinc-100 rounded text-zinc-400 hover:text-red-500 transition-colors"
                  title="sale.sale.delivery_change"
                >
                  <EditIcon />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
